module.exports = __webpack_public_path__ + "static/media/value.dacc43d4.png";